import { NotifyService } from "app/notify/notify.service";
import { TOAST } from "app/notify/toast/toast-type.enum";
import { Injectable, inject } from "@angular/core";

@Injectable()
export class ClipboardService {
  private notifyService = inject(NotifyService);

  public copyToClipboard(originalText: string): void {
    // Remove HTML
    const textToBeCopied = originalText.replace(/<[^>]*>?/gm, "");
    const blobHtml = new Blob([originalText], { type: "text/html" });
    const blobText = new Blob([textToBeCopied], { type: "text/plain" });
    const data = [
      new ClipboardItem({
        ["text/plain"]: blobText,
        ["text/html"]: blobHtml,
      }),
    ];

    if (navigator?.clipboard?.write) {
      navigator.clipboard.write(data).then(
        () => {
          this.notifyService.toast(
            TOAST.INFO,
            "Success",
            "Description has been copied to your clipboard",
          );
        },
        () => {
          this.notifyService.toast(
            TOAST.ERROR,
            "Error",
            "Can't copy to clipboard",
          );
        },
      );
    } else {
      this.notifyService.toast(
        TOAST.ERROR,
        "Error",
        "Your browser does not support copying to clipboard",
      );
    }
  }
}
